import {Avatar, Button, DatePicker, Input, message, Modal, Radio} from 'antd'
import {course_class_getAttendanceDetails_Api, course_class_setAttendanceStatus_Api,} from 'apis'
import {getId} from 'apis/model/base'
import classNames from 'classnames'
import {showConfirm} from 'components/Feed/TimeLineFeed'
import FieldsFactory from 'components/form/FieldsFactory'
import {ResetButton, SubmitButton} from 'components/form/FormActionBar'
import {createValue} from 'components/form/utils'
import Pure from 'components/Pure'
import {Formik} from 'formik'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import withTranslate from 'modules/local/withTranslate'
import React, {useCallback, useContext, useMemo, useState} from 'react'
import {BsInfoCircleFill, BsPersonBadge, BsQrCodeScan} from 'react-icons/bs'
import {IoCalendarOutline, IoQrCodeOutline} from 'react-icons/io5'
import {compose, mapProps, pure} from 'recompose'
import EntityList from 'views/AppLocals/EntityList'
import {notifyOnError} from 'views/AppLocals/factory/createErrorEvent'
import {createControlledFormField} from 'views/AppLocals/factory/createFormField'
import {bindQueryParam} from 'views/AppLocals/functions/routerHelper'
import {NullAsDefault, renderIf, shallowDiff} from 'views/Shared'
import {attendance_status_options} from '..'
import {
    course_class_attendanceCheckIn_Api,
    course_class_getAttendanceDetailsByStudent_Api,
    course_class_student_getAttendanceResult_Api
} from '../../../../apis'
import {formatDate, getDateString, parseDayjs, renderFromToTime} from '../../../../helpers/datetimeHelpers'
import {deepTranslate, renderIfElse} from '../../../Shared'
import {IdentifierTypes} from '../../appFieldTypes'
import {gConfigs} from '../../configs'
import {createNumberControlledInput} from '../../factory/createFormField'
import {bindQueryParams} from '../../functions/routerHelper'
import {HeaderWithIconLine, ListHeaderLineAndDes, ListHeaderWithLine,} from '../../Templates/items/ListHeader'
import {CourseClassTimetableDetailSelector} from '../components/CourseClassTimetableDetailSelector'
import {SubjectSelector} from '../components/SubjectSelector'
import CourseClassInformation from './CourseClassInformation'
import {ItemInformation} from "../../Organization/OrganizationEntity";
import {SelectWidget} from "../../custom/ReactSelectComponents";
import {renderEmptyHolder} from "../../../../components/EmptyHolder";
import {SubClassTags} from "../components/SubClassTags";
import {FaAddressCard, FaUserGraduate, FaUserTie} from "react-icons/fa6";
import copyToClipboard from "copy-to-clipboard";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {useQrScanner} from "../../../../hooks/useQrScanner";
import getAvatar from "../../../../helpers/getAvatar";
import {showErrorDialog} from "../../factory/createErrorDialog";
import {DatePlaceItem, DoubleValueItem} from "../../CatholicHousehold/components/CatholicHouseholdComponents";
import {ObjectSelectField} from "../../../../components/form/fields/ObjectSelectField";
import {extractTypeAndIdFromUrl} from "../../../../helpers/stringUtils";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import getLabelOfGender from "../../../../helpers/getLabelOfGender";
import getAliasName from "../../../../helpers/getAliasName";
import dayjs from "dayjs";
import {ActionModalWrapper} from "../../../../components/form/ActionModalWrapper";
import AttendanceInput from "../../../../components/form/fields/AttendanceInput";
import {TbAlertTriangle} from "react-icons/tb";
import {PiCheckLight, PiClockClockwiseLight} from "react-icons/pi";
import {MdOutlineCancel} from "react-icons/md";
import {ifThenElseMultipleConditions} from "../../../../helpers/ifThenElseMultipleConditions";

const formSchema = {
    title: {
        title: 'title',
        children: [
            {
                description: 'create lesson description',
                name: 'title',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, translate, onChange}) => ({
                        name,
                        value,
                        onChange,
                        placeholder: translate('ex: dddd, DD/MM/YYYY'),
                        addonBefore: (
                            <span className="font-medium text-sm text-color-400 italic">
                {translate('lesson on')}
              </span>
                        ),
                    })),
                    pure
                )(Input),
            },
        ],
    },
    default_value: {
        title: 'default attendance status',
        children: [
            {
                name: 'default_value',
                component: compose(
                    withTranslate,
                    mapProps(({translate, name, value, onChange}) => ({
                        name,
                        value,
                        onChange: onChange,
                        buttonStyle: 'solid',
                        className: 'custom-radio-button-sm',
                        defaultValue: 0,
                        children: [
                            {label: 'not check in', value: 0},
                            {label: 'in attendance', value: 1},
                            {label: 'unexcused absence', value: -2},
                        ].map(({value, label}) => (
                            <Radio.Button
                                key={value}
                                value={value}>
                                {translate(label)}
                            </Radio.Button>
                        )),
                    }))
                )(Radio.Group),
            },
        ],
    },
    status: {
        title: 'status',
        children: [
            {
                name: 'status',
                component: ({name, value, form, onChange}) => {
                    const options = Array.from(form?.values?.status_options ?? [])
                    return (
                        <Translate>
                            {(t) => (
                                <Radio.Group
                                    name={name}
                                    value={value}
                                    options={options.map(({value, label}) => ({
                                        value: value,
                                        label: (
                                            <span className="font-medium text-sm text-color-100 italic">
                                                {t(label)}
                                            </span>
                                        ),
                                    }))}
                                    className="mt-1 flex flex-col md:flex-row gap-2 custom-radio-button"
                                    onChange={(event) => {
                                        onChange(createValue(name, event.target.value))
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
        ],
    },
    attendance_state: {
        children: [
            {
                name: 'attendance_state',
                component: ({name, value, form, onChange}) => {
                    return (
                        <AttendanceInput
                            defaultValues={value}
                            onValuesChange={(values) => {
                                form.setValues({
                                    ...form.values,
                                    ...values,
                                    attendance_state: values
                                })
                            }}
                        />
                    )
                },
            },
        ],
    },
    absent_reason: {
        title: 'reason',
        children: [
            {
                name: 'absent_reason',
                component: createControlledFormField({
                    rows: 3,
                    placeholder: 'reason',
                    Component: Input.TextArea,
                }),
            },
        ],
    },
    course_subject__sessions: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-2 gap-3',
        children: [
            {
                label: 'subjects',
                name: 'subject',
                component: mapProps(({name, value, form, onChange}) => {
                    const {subject_id, course_class} = form?.values ?? {}
                    const {class_subjects = []} = course_class;
                    const subjects = class_subjects.map(e => ({
                        id: e.subject.id,
                        value: e.subject.id,
                        label: e.subject.title,
                        ...e.subject
                    }));

                    return {
                        name,
                        onChange,
                        onOptionChange: (option) => {
                            onChange(createValue(name, option ?? null))
                        },
                        value: _.find(subjects, {value: subject_id,})?.id,
                        showSearch: true,
                        options: subjects,
                        style: {
                            padding: 0,
                            border: 0,
                        }
                    }
                })(ObjectSelectField),
            },
            {
                label: 'number of sessions',
                name: 'number_of_sessions',
                component: createNumberControlledInput({
                    placeholder: 'number of sessions',
                }),
            },
        ],
    },
    number_of_sessions: {
        title: 'number of sessions',
        children: [
            {
                name: 'number_of_sessions',
                component: createNumberControlledInput({
                    placeholder: 'number of sessions',
                }),
            },
        ],
    },
    course_class_timetable_detail: {
        title: 'timetables',
        children: [
            {
                name: 'course_class_timetable_detail',
                component: compose(mapProps(({name, value, form, onChange}) => {
                    const {course_class_id, subject, subject_id, course_class_timetable_detail_id} = form?.values ?? {}
                    return {
                        name,
                        value,
                        onChange,
                        course_class_id,
                        subject_id: subject?.id || subject_id,
                        course_class_timetable_detail_id,
                        dependencies: [subject_id, course_class_id, course_class_timetable_detail_id]
                    }
                }), pure)
                (CourseClassTimetableDetailSelector),
            },
        ],
    },
    attendance_date: {
        title: 'attendance date',
        children: [
            {
                name: 'attendance_date',
                component: ({name, value, onChange}) => {
                    return (
                        <Translate>
                            {(t) => (
                                <DatePicker
                                    key={value}
                                    className="w-full"
                                    suffixIcon={<IoCalendarOutline className="text-color-500"/>}
                                    allowClear={false}
                                    format={gConfigs.dateFormat}
                                    defaultValue={value}
                                    placeholder={t('attendance date')}
                                    onChange={(value) => {
                                        onChange(createValue(name, value))
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
        ],
    },
}


const getStatusConfig = (status) => {
    switch (status) {
        case -1:
        case -2:
            return {color: 'bg-red-50 text-red-700 border-red-300', icon: MdOutlineCancel, iconColor: 'text-red-500'};
        case -3:
            return {
                color: 'bg-yellow-50 text-yellow-700 border-yellow-300',
                icon: TbAlertTriangle,
                iconColor: 'text-yellow-500'
            };
        case 1:
        default:
            return {
                color: 'bg-green-50 text-green-700 border-green-300',
                icon: PiCheckLight,
                iconColor: 'text-green-500'
            };
    }
};

const AttendanceStatusBadge = ({status}) => {
    const {color, icon: Icon, iconColor} = getStatusConfig(status);
    return (
        <div
            className={classNames("flex items-center space-x-2 px-3 py-1 rounded-full text-xs font-semibold shadow-sm", color)}>
            {/*<Icon size={14} className={iconColor}/>*/}
            <span>{getTitle({status})}</span>
        </div>
    );
};

/**
 * Redesigned component to render attendance detail item.
 * @param {Object} props
 * @param {function} props.renderActions - Function to render actions.
 * @param {string} props.primary_type - 'student' or 'session'.
 * @returns {function} The rendering function (item, index) => ReactElement
 */
const renderAttendantDetail = ({renderActions = NullAsDefault, primary_type = 'student'} = {}) =>
    (item, index) => {
        const t = useTranslate();
        const {student, attendance, absent_reason, number_of_sessions} = item ?? {};
        const {patron_saint_name, fullname} = student ?? {};

        const status = attendance?.status || (absent_reason ? 'ABSENT' : 'PRESENT');
        const {color: cardColor} = getStatusConfig(status);

        return (
            <div key={index} className={classNames(
                "p-4 mb-4 border-l-4 rounded-xl shadow-lg transition duration-300 ease-in-out hover:shadow-xl bg-white",
                ifThenElseMultipleConditions(
                    'border-gray-200',
                    status === 'ABSENT', 'border-red-400',
                    status === 'LATE', 'border-yellow-400',
                    status === 'PRESENT', 'border-green-600',
                ),
            )}>
                <div className="flex justify-between items-start">
                    {/* LEFT SECTION: MAIN CONTENT */}
                    <div className="flex flex-col flex-1 min-w-0 pr-4">

                        {/* 1. PRIMARY TITLE (Student Name or Session Title) */}
                        {renderIf(
                            primary_type === 'student',
                            <div className="font-bold text-lg text-gray-800 tracking-wide truncate">
                                    <span className="font-medium text-gray-500 mr-1 flex-shrink-0">
                                        {`${index + 1}. `}
                                    </span>
                                {renderIf(
                                    patron_saint_name,
                                    <span className="mr-1 font-medium text-blue-600">
                                            {getAliasName(student, 'patron_saint')}
                                        </span>
                                )}
                                {fullname}
                            </div>,
                            <div className="font-bold text-lg text-gray-800 tracking-wide truncate">
                                    <span className="font-medium text-gray-500 mr-1 flex-shrink-0">
                                        {`${index + 1}. `}
                                    </span>
                                {getTitle(attendance)}
                            </div>
                        )}


                        {/* 3. SECONDARY INFO (Session Details / Reason) */}
                        <div className="mt-3 space-y-2 text-sm">
                            {/* Session Details (for non-student type or if student is absent/late) */}
                            {renderIf(
                                primary_type !== 'student',
                                <div
                                    className="flex flex-wrap items-center gap-x-4 gap-y-1 font-medium text-gray-600 italic">
                                    <PiClockClockwiseLight size={14} className="text-gray-400 flex-shrink-0"/>
                                    <span>{renderFromToTime(attendance?.attendance_date)}</span>
                                    <span>•</span>
                                    <span
                                        className="font-semibold text-gray-800">{getTitle(attendance?.subject)}</span>
                                </div>
                            )}

                            {/* Absent Reason */}
                            {renderIf(
                                absent_reason,
                                <div className="font-semibold text-sm text-red-600 flex items-start space-x-1">
                                    <TbAlertTriangle size={14} className="text-red-500 mt-1 flex-shrink-0"/>
                                    <span className="font-medium text-gray-700">
                                            {`${t('reason')} : `}
                                        <span className="font-normal text-gray-600 italic">
                                                {absent_reason}
                                            </span>
                                        </span>
                                </div>
                            )}

                            {/* Duration Attended */}
                            {renderIf(
                                number_of_sessions,
                                <ItemInformation
                                    showIcon={true}
                                    label="duration attended"
                                    value={`${number_of_sessions} ${t('sessions')}`}
                                    className="text-xs italic"
                                />
                            )}
                        </div>
                    </div>

                    {/* RIGHT SECTION: ACTIONS */}
                    <div className="flex-shrink-0">
                        {renderActions(item)}
                    </div>
                </div>
            </div>
        )
    }

export const CourseClassAttendanceCreateForm = ({
                                                    course_class,
                                                    initialValues,
                                                    onSubmit = NullAsDefault,
                                                    isSubmitting = false,
                                                }) => {
    const t = useTranslate()

    const course_id = getId(course_class?.course)

    const _initialValues = useMemo(
        () => ({
            course_id,
            title: _.capitalize(dayjs().format('dddd, DD/MM/YYYY')),
            default_value: 0,
            number_of_sessions: 1,
            attendance_date: dayjs(),
            course_class_id: course_class?.id,
            course_class,
            ...(initialValues ?? {}),
        }),
        [course_id, course_class, initialValues]
    )

    const validate = (values) => {
        let errors = {}

        const {title} = values ?? {}

        if (_.isEmpty(title ?? '')) {
            errors.title = t('required field')
        }

        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={_initialValues}
            onSubmit={(values) => {
                const {
                    subject,
                    course_id,
                    attendance_date,
                    course_class_timetable_detail,
                    ...rest
                } = values ?? {}
                onSubmit(
                    _.omitBy(
                        {
                            ...rest,
                            subject_id: values?.subject ? getId(subject) : null,
                            course_class_timetable_detail_id: getId(
                                course_class_timetable_detail
                            ),
                            attendance_date: getDateString(attendance_date),
                        },
                        _.isUndefined
                    )
                )
            }}>
            <ActionModalWrapper
                className="gap-3"
                action={
                    <div className="flex items-center justify-end p-2 background">
                        <ResetButton disabled={isSubmitting}/>
                        <SubmitButton
                            label="create"
                            dirtyRequired={false}
                            loading={isSubmitting}
                        />
                    </div>
                }>
                <CourseClassInformation
                    item={course_class}
                    showDescription={false}
                />
                <FieldsFactory
                    formSchema={[
                        formSchema.title,
                        formSchema.course_subject__sessions,
                        // formSchema.course_subject,
                        // formSchema.number_of_sessions,
                        formSchema.attendance_date,
                        formSchema.course_class_timetable_detail,
                        formSchema.default_value,
                    ]}
                />
            </ActionModalWrapper>
        </Formik>
    )
}

export const CourseClassAttendanceUpdateForm = ({
                                                    course_class,
                                                    initialValues,
                                                    onSubmit = NullAsDefault,
                                                    isSubmitting = false,
                                                }) => {
    const t = useTranslate()
    const course_id = getId(course_class?.course)
    const course_class_id = getId(course_class)
    const _initialValues = useMemo(() => {
        const {attendance_date, ...rest} = initialValues ?? {}
        return {
            course_id,
            course_class_id,
            subject_id: initialValues?.subject_id || initialValues?.subject?.id,
            course_class,
            attendance_date: parseDayjs(attendance_date),
            ...rest,
        }
    }, [course_id, course_class_id, initialValues]);

    const validate = (values) => {
        let errors = {}

        const {title} = values ?? {}

        if (_.isEmpty(title ?? '')) {
            errors.title = t('required field')
        }

        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={_initialValues}
            onSubmit={(values) => {
                const changes = shallowDiff(values, _initialValues)
                const {
                    subject,
                    course_id,
                    attendance_date,
                    course_class_timetable_detail,
                    ...rest
                } = changes ?? {}
                onSubmit(
                    _.omitBy(
                        {
                            ...rest,
                            subject_id: values?.subject ? getId(subject) : null,
                            attendance_date: getDateString(attendance_date),
                            course_class_timetable_detail_id:
                                values?.course_class_timetable_detail
                                    ? getId(course_class_timetable_detail)
                                    : null,
                        },
                        _.isUndefined
                    )
                )
            }}>
            <ActionModalWrapper
                className="gap-4"
                action={
                    <div className="flex items-center justify-end p-2 background">
                        <ResetButton disabled={isSubmitting}/>
                        <SubmitButton
                            label="save"
                            dirtyRequired={false}
                            loading={isSubmitting}
                        />
                    </div>
                }>
                <CourseClassInformation
                    item={course_class}
                    showDescription={false}
                />
                <Pure>
                    <FieldsFactory
                        formSchema={[
                            formSchema.title,
                            formSchema.course_subject__sessions,
                            // formSchema.course_subject,
                            // formSchema.number_of_sessions,
                            formSchema.course_class_timetable_detail,
                            formSchema.attendance_date,
                        ]}
                    />
                </Pure>
            </ActionModalWrapper>
        </Formik>
    )
}

const CheckInContent = ({item, status_options, onSubmit = NullAsDefault, onCancel = NullAsDefault}) => {
    const t = useTranslate()

    const initialValues = useMemo(
        () => ({
            status_options,
            absent_reason: undefined,
            ...(item ?? {}),
            attendance_state: {
                status: item?.status,
                number_of_sessions: item?.number_of_sessions,
                absent_reason: item?.absent_reason
            }
        }),
        [item, status_options]
    )

    const validate = (values) => {
        let errors = {}
        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={({status_options, attendance_state, ...values}) => {
                const {status, number_of_sessions, absent_reason} = values ?? {}
                onSubmit(
                    _.omitBy(
                        {
                            status,
                            number_of_sessions,
                            absent_reason: absent_reason ?? undefined,
                        },
                        _.isUndefined
                    )
                )
            }}>
            <div className="flex flex-col gap-6">
                <div className="flex flex-col gap-4">
                    <FieldsFactory formSchema={[
                        formSchema.attendance_state
                    ]}/>
                </div>
                <div className="flex items-center justify-end p-2 background">
                    {/*<ResetButton />*/}
                    <SubmitButton
                        label="save"
                        dirtyRequired={false}
                    />
                </div>
            </div>
        </Formik>
    )
}


export const CourseClassAttendantsForm = ({item, attendance}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const [current, setCurrent] = useState()

    const [keyword, setKeyword] = useState()
    const [responseItem, setResponseItem] = useState(null)
    const [sub_class_name, setSubClassName] = useState()

    const {handleAsyncAction: attendanceCheckIn} = useAsyncAction({
        onError: (error, errorObj) => showErrorDialog(t)({
            error, errorObj,
            icon: <BsQrCodeScan size={20} style={{color: 'var(--color-primary-500)'}} className="anticon"/>,
            closable: true,
            maskClosable: true,
            okText: t('try again'),
            cancelText: t('close'),
            okButtonProps: {
                type: 'default',
                className: 'button-rounded-md no-border bg-primary-50 hover:bg-primary-100 text-primary',
            },
            cancelButtonProps: {
                className: 'button-rounded-md no-border',
            },
            onOk: () => {
                openQRScanner()
            },
            onCancel: () => {
                closeQRScanner()
            },
        }),
        apiInfo: course_class_attendanceCheckIn_Api,
        onSuccess: (result, data) => {
            const dataItem = _.get(data, 'response.data');
            setResponseItem(dataItem);
            closeQRScanner()
        },
    })
    const {qrModal, openQRScanner, isOpenQRScanner, closeQRScanner} = useQrScanner({
        item: attendance,
        loopNumber: 30,
        doSubmit: (result_text) => {
            if (result_text.includes("|")) {
                const texts = (result_text || "").split("|")
                attendanceCheckIn({
                    ref_type: (texts[0] ?? null),
                    ref_id: (texts[1] ?? null)
                }, {attendance_id: attendance?.id})
            } else {
                const typeId = extractTypeAndIdFromUrl(result_text || "")
                attendanceCheckIn({
                    ref_type: (typeId?.type ?? null),
                    ref_id: (typeId?.id ?? null)
                }, {attendance_id: attendance?.id})
            }
        }
    })

    const {title, course_class, subject} = attendance ?? {}

    const qrResultModal = useMemo(() => {
        const {student, number_of_sessions, status} = responseItem ?? {}
        const {avatar, patron_saint_name, fullname, student_idcode, date_of_birth, user} = student ?? {}

        const labelStatus = _.find(attendance_status_options, {value: status})?.label

        return (
            <Modal
                title={
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('attendance of students')}
                    </div>
                }
                width={600}
                className="custom-modal"
                closable={false}
                open={true}
                maskClosable={false}
                destroyOnHidden={true}
                header={null}
                footer={null}>
                <div className="w-full flex flex-col items-center gap-3">
                    <Avatar
                        size={200}
                        src={avatar || getAvatar(user)}
                        icon={<FaUserGraduate size={100} style={{color: '#dedede'}}/>}
                        className="flex flex-center background-200 rounded-lg"
                    />
                    <div className="w-full flex flex-col gap-2">
                        <div className="flex flex-col flex-center mb-2">
                            <span style={{fontSize: 22}}
                                  className="text-center font-extrabold text-primary tracking-widest leading-snug">
                                {`${patron_saint_name || ''} ${fullname}`}
                            </span>
                            <span className="font-medium text-2xs text-blue-500 italic tracking-wider leading-tight">
                                {`#${student_idcode}`}
                            </span>
                            {renderIf(
                                date_of_birth,
                                <div style={{marginTop: 3, fontSize: 11}}
                                     className="flex items-center gap-1 italic leading-tight">
                                            <span className="text-color-400 whitespace-no-wrap">
                                                {t('date of birth')}
                                            </span>
                                    <span className="font-bold text-color-100 tracking-wider leading-tight">
                                        {date_of_birth ? formatDate(date_of_birth, 'DD/MM/YYYY') : t('not update')}
                                    </span>
                                </div>
                            )}
                        </div>
                        <ItemInformation
                            primary={true}
                            label="classes"
                            value={getTitle(course_class)}
                            className="text-sm italic"
                        />
                        <ItemInformation
                            label="lesson on"
                            value={title}
                            className="text-sm italic"
                        />
                        <DoubleValueItem
                            labelFirst="subjects"
                            valueFirst={getTitle(subject)}
                            labelSecond=' - '
                            valueSecond={`${number_of_sessions} ${t('sessions')}`}
                            className="text-sm italic"
                        />
                        <div className="flex items-baseline gap-1 text-sm italic">
                            <span className="text-color-500 whitespace-no-wrap">
                                {`${t('status')} : `}
                            </span>
                            <span className="font-bold text-sm text-green-600">
                                {t(labelStatus)}
                            </span>
                        </div>
                    </div>
                    <div className="flex flex-col items-center gap-4 mt-2 mb-2">
                        <div
                            onClick={() => {
                                setResponseItem(null);
                                openQRScanner();
                            }}
                            style={{height: 30, padding: '4px 16px', fontSize: 14, letterSpacing: '0.1em'}}
                            className="flex flex-center rounded-md bg-green-100 hover:bg-green-200 font-semibold text-green-700 leading-snug">
                            {t('continue attendance')}
                        </div>
                        <div
                            onClick={() => {
                                setResponseItem(null);
                            }}
                            style={{fontSize: 12, letterSpacing: '0.1em'}}
                            className="font-semibold text-color-300 hover:text-color-100 cursor-pointer leading-snug">
                            {t('close')}
                        </div>
                    </div>

                    <div className="flex justify-end p-3 mt-6 md:mt-8">
                        <div onClick={() => {
                            closeQRScanner()
                        }} className="font-medium text-color-200 hover:text-color-000 cursor-pointer">
                            {t('close')}
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }, [responseItem]);

    const onCancel = () => {
        setCurrent(null)
    }
    const attendance_id = getId(attendance)
    const {number_of_students} = item ?? {}
    const apiInfo = course_class_getAttendanceDetails_Api
    const refreshKey = useMemo(
        () =>
            [
                apiInfo.path.replace(':id', attendance_id),
                JSON.stringify(keyword),
                sub_class_name
            ].join('/'),
        [keyword, sub_class_name, attendance_id]
    )

    const status_options = [
        attendance_status_options.present,
        attendance_status_options.absent,
        attendance_status_options.absent_reason,
    ]

    const {handleAsyncAction: setAttendanceStatus} = useAsyncAction({
        onError: notifyOnError(t),
        apiInfo: course_class_setAttendanceStatus_Api,
        // onSuccess: (result, data) => {
        //   successNotify(NotificationActionTypes.INFORMATION, t)
        // },
    })

    const onSearch = _.debounce((keyword) => {
        setKeyword(keyword)
    }, 500)

    const renderActions = useCallback(
        (item) => {
            let params = {}
            if (item?.status === 1) {
                params.type = 'dashed'
                params.style = {color: 'green'}
                params.label = 'attended'
            }
            if (item?.status === 0) {
                params.type = 'dashed'
                params.style = {color: 'grey'}
                params.label = attendance_status_options.reset.label
            }
            if (item?.status === -1) {
                params.danger = true
                params.type = 'dashed'
                params.style = {color: 'orange'}
                params.label = attendance_status_options.absent_reason.label
            }
            if (item?.status === -2) {
                params.danger = true
                params.type = 'dashed'
                params.style = {color: 'red'}
                params.label = attendance_status_options.absent.label
            }

            const {student} = item ?? {}

            return renderIfElse(
                item?.status === 0,
                <div className="flex flex-col items-center">
                    <div
                        className="flex flex-center bg-blue-100 hover:bg-blue-200 font-bold text-blue-600 leading-tight cursor-pointer"
                        style={{border: 0, height: 22, fontSize: 11, padding: '0 10px', borderRadius: 6}}
                        onClick={(e) => {
                            e.preventDefault()
                            showConfirm({
                                icon: <BsPersonBadge style={{color: '#38a169'}} className="anticon"/>,
                                title: (
                                    <span className="font-semibold text-color-100">
                                        {t('attendance of students')}
                                    </span>
                                ),
                                content: (
                                    <div className="flex flex-col space-y-3">
                                        <div className="flex items-center gap-x-1 italic">
                                            <Avatar
                                                size={28}
                                                icon={<FaUserTie size={12} className="text-color-500"/>}
                                                className="flex flex-center background-200"
                                            />
                                            <span className="font-medium text-color-100">
                                                {_.get(student, 'patron_saint_name') || _.get(student, 'prefix_title')}
                                            </span>
                                            <span className="font-bold text-color-000">
                                                {_.get(student, 'user.name', _.get(student, 'fullname'))}
                                            </span>
                                        </div>
                                        <div className="text-sm text-color-500 italic">
                                            {t('are you sure this student attended your class')}
                                        </div>
                                    </div>
                                ),
                                okText: t('sure'),
                                cancelText: t('ignore'),
                                okButtonProps: {
                                    type: 'primary',
                                    className: 'button-rounded-lg no-border',
                                },
                                cancelButtonProps: {
                                    type: 'text',
                                    className: 'button-rounded-lg no-border',
                                },
                                onOk: () => {
                                    setAttendanceStatus(
                                        {status: attendance_status_options.present.value},
                                        {attendance_id, detail_id: getId(item)}
                                    )
                                },
                            })
                        }}>
                        {t(attendance_status_options.present.label)}
                    </div>
                    <span
                        className="font-medium text-xs text-primary-500 hover:text-primary cursor-pointer tracking-wide leading-snug"
                        style={{marginTop: 5, fontSize: 11, padding: '0 10px',}}
                        onClick={(e) => {
                            e.preventDefault()
                            let temp = Object.assign({}, item)
                            if (!status_options.includes(temp?.status)) {
                                temp.status = attendance_status_options.absent.value
                            }
                            setCurrent(temp)
                        }}>
                        {/*{t(attendance_status_options.absent.label)}*/}
                        {t('absent')}
                    </span>
                </div>,
                <Button
                    size="small"
                    name="status"
                    style={{width: 'fit-content', border: 0, height: 22, fontSize: 11, padding: '0 10px'}}
                    className="flex flex-center button-rounded-md font-bold text-xs italic border-transparent hover:border-current leading-tight"
                    {...params}
                    onClick={(e) => {
                        e.preventDefault()
                        if (item?.status === 1) {
                            let temp = Object.assign({}, item)
                            setCurrent(temp)
                        } else {
                            showConfirm({
                                icon: <BsPersonBadge className="anticon 2222"/>,
                                title: (
                                    <span className="font-bold text-color-000">
                                        {t('attendance of students')}
                                    </span>
                                ),
                                content: (
                                    <div className="flex flex-col space-y-3">
                                        <div className="text-sm text-color-200 font-medium">
                                            {_.get(item, 'student.user.name', _.get(item, 'student.fullname'))}
                                        </div>
                                        <div className="text-sm text-color-500 italic">
                                            {t('are you sure this student attended your class')}
                                        </div>
                                    </div>
                                ),
                                okText: t('sure'),
                                cancelText: t('ignore'),
                                okButtonProps: {
                                    type: 'primary',
                                    className: 'button-rounded-lg no-border',
                                },
                                cancelButtonProps: {
                                    type: 'text',
                                    className: 'button-rounded-lg no-border',
                                },
                                onOk: () => {
                                    setAttendanceStatus(
                                        {status: attendance_status_options.present.value},
                                        {attendance_id, detail_id: getId(item)}
                                    )
                                },
                            })
                        }
                    }}>
                    {t(params.label)}
                </Button>
            )
        },
        [attendance_id]
    )

    const {student} = current ?? {}

    return renderIf(
        attendance_id,
        <div className="flex flex-col space-y-3 p-3 relative">
            <div className="flex flex-col gap-1">
                <HeaderWithIconLine
                    icon={<BsInfoCircleFill size={14} className="text-color-500"/>}
                    title="lesson information"
                    className="text-sm text-color-300"
                />
                <div className="flex flex-col gap-1 ml-1 md:ml-3">
                    <ItemInformation
                        primary={true}
                        showIcon={true}
                        className="text-xs italic"
                        label="classes"
                        value={getTitle(item)}
                    />
                    <ItemInformation
                        showIcon={true}
                        className="text-xs italic"
                        label="lesson on"
                        value={getTitle(attendance).split(" - ")[0]}
                    />
                    <ItemInformation
                        showIcon={true}
                        className="text-xs italic"
                        label="subjects"
                        value={_.get(attendance?.subject, 'title')}
                    />
                    <ItemInformation
                        showIcon={true}
                        className="text-xs italic"
                        label="number of student"
                        value={`${number_of_students} ${t('students')}`}
                    />
                    <ItemInformation
                        showIcon={true}
                        className="text-xs italic"
                        label="duration"
                        value={`${attendance?.number_of_sessions} ${t('sessions')}`}
                    />
                </div>
            </div>
            {
                isSm && (
                    <div className="flex justify-end">
                        {!!responseItem && qrResultModal}
                        {isOpenQRScanner && qrModal}
                        <div
                            onClick={() => {
                                openQRScanner()
                            }}
                            style={{
                                width: 'fit-content',
                                height: 28,
                                borderRadius: 6,
                                padding: '0 10px',
                            }}
                            className="flex flex-center bg-primary-50 text-primary cursor-pointer">
                            <IoQrCodeOutline size={12} className="mr-2 text-primary-500"/>
                            <span className="font-semibold text-xs leading-tight tracking-wide">
                            {t('check in')}
                        </span>
                        </div>
                    </div>
                )}
            <div className="flex flex-col space-y-3">
                <Input.Search
                    name="keyword"
                    autoComplete="off"
                    allowClear={true}
                    onSearch={onSearch}
                    placeholder={t('type to search')}
                    className="input-search-with-icon"
                    onChange={(event) => {
                        onSearch(event.target?.value)
                    }}
                />
                <SubClassTags
                    items={_.get(item, 'sub_class_names', [])}
                    selected={sub_class_name}
                    setSelected={setSubClassName}
                />
            </div>
            <div className="flex flex-col gap-3">
                <ListHeaderLineAndDes
                    renderTitle={() => (
                        <span className="font-semibold text-sm text-color-300 uppercase tracking-wider">
                            {t('list of students')}
                        </span>
                    )}
                    description="description attendance of students"
                />
                <EntityList
                    apiInfo={apiInfo}
                    values={{keyword, sub_class_name}}
                    refreshKey={refreshKey}
                    query={bindQueryParam({id: attendance_id})}
                    renderItem={renderAttendantDetail({renderActions})}
                />
            </div>
            {
                current && (
                    <Modal
                        footer={null}
                        open={current}
                        onCancel={onCancel}
                        destroyOnHidden={true}
                        className="custom-modal"
                        title={
                            <div className="text-center text-color-000 font-bold uppercase">
                                {t('student requests absence')}
                            </div>
                        }>
                        <div className="flex flex-col gap-4">
                            <div className="flex flex-col gap-1">
                                <div className="font-semibold text-sm text-color-300 uppercase tracking-wide">
                                    {t('student information')}
                                </div>
                                <div className="flex items-center gap-2">
                                    <Avatar
                                        size={36}
                                        src={student?.avatar || student?.user?.avatar}
                                        icon={<FaUserTie size={14} className="text-color-500"/>}
                                        className="flex flex-center background-200"
                                    />
                                    <div className="flex flex-col">
                                    <span className="font-bold text-color-000">
                                        {student?.prefix_title || student?.patron_saint_name || ''} {getTitle(student)}
                                    </span>
                                        <div className="flex items-center gap-6">
                                            {renderIf(
                                                student?.student_idcode,
                                                <div className="text-color-500 text-xs italic">
                                                <span className="whitespace-no-wrap">
                                                    {isSm ? '#' : `${t('student code')} : `}
                                                </span>
                                                    <span
                                                        onClick={() => {
                                                            copyToClipboard(student?.student_idcode)
                                                            message.info(t('copied'))
                                                        }}
                                                        className="font-semibold text-color-300">
                                                {student?.student_idcode}
                                            </span>
                                                </div>
                                            )}
                                            {renderIf(
                                                student?.identifier_code,
                                                <div className="flex items-center text-color-500 text-xs gap-1">
                                                    {isSm ?
                                                        <FaAddressCard size={12} className="mr-1"/> :
                                                        <span className="mr-1 italic whitespace-no-wrap">
                                                    {`${t(_.find(IdentifierTypes, {value: student?.identifier_type})?.label)} : `}
                                                </span>
                                                    }
                                                    <span
                                                        onClick={() => {
                                                            copyToClipboard(student?.identifier_code)
                                                            message.info(t('copied'))
                                                        }}
                                                        className="font-semibold text-blue-500">
                                                {student?.identifier_code}
                                            </span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <CheckInContent
                                item={current}
                                status_options={status_options}
                                onSubmit={(values) => {
                                    setAttendanceStatus(values, {
                                        attendance_id,
                                        detail_id: getId(current),
                                    })
                                    onCancel()
                                }}
                                onCancel={onCancel}
                            />
                        </div>
                    </Modal>
                )}
        </div>
    )
}

export const CourseClassStudentAttendantsForm = ({courseClass, student}) => {
    const t = useTranslate()

    const [current, setCurrent] = useState()

    const [keyword, setKeyword] = useState()

    const onCancel = () => {
        setCurrent(null)
    }

    const apiInfo = course_class_getAttendanceDetailsByStudent_Api

    const refreshKey = useMemo(
        () =>
            [
                apiInfo.path
                    .replace(':id', courseClass?.id)
                    .replace(':student_id', student?.id),
                JSON.stringify(keyword),
            ].join('/'),
        [keyword, courseClass, student]
    )

    const status_options = [
        attendance_status_options.absent,
        attendance_status_options.absent_reason,
    ]

    const {handleAsyncAction: setAttendanceStatus} = useAsyncAction({
        onError: notifyOnError(t),
        apiInfo: course_class_setAttendanceStatus_Api,
        // onSuccess: (result, data) => {
        //   successNotify(NotificationActionTypes.INFORMATION, t)
        // },
    })

    const onSearch = _.debounce((keyword) => {
        setKeyword(keyword)
    }, 500)

    const renderActions = useCallback(
        (item) => {
            let params = {}
            if (item?.status === 1) {
                params.type = 'dashed'
                params.style = {color: 'green'}
                params.label = attendance_status_options.present.label
            }
            if (item?.status === 0) {
                params.type = 'dashed'
                params.style = {color: 'grey'}
                params.label = attendance_status_options.reset.label
            }
            if (item?.status === -1) {
                params.danger = true
                params.type = 'dashed'
                params.style = {color: 'orange'}
                params.label = attendance_status_options.absent_reason.label
            }
            if (item?.status === -2) {
                params.danger = true
                params.type = 'dashed'
                params.style = {color: 'red'}
                params.label = attendance_status_options.absent.label
            }
            return (
                <Button
                    className="button-rounded-xs font-semibold text-xs border-transparent hover:border-current"
                    size="small"
                    name="status"
                    {...params}
                    onClick={(e) => {
                        e.preventDefault()
                        if (item?.status === 1) {
                            let temp = Object.assign({}, item)
                            if (!status_options.includes(temp?.status)) {
                                temp.status = attendance_status_options.absent.value
                            }
                            setCurrent(temp)
                        } else {
                            showConfirm({
                                icon: <BsPersonBadge className="anticon 11111"/>,
                                title: (
                                    <span className="font-bold text-color-000">
                    {t('attendance of students')}
                  </span>
                                ),
                                content: (
                                    <div className="flex flex-col space-y-3">
                                        <div className="text-sm text-color-200 font-medium">
                                            {_.get(item, 'student.user.name', _.get(item, 'student.fullname'))}
                                        </div>
                                        <div className="text-sm text-color-500 italic">
                                            {t('are you sure this student attended your class')}
                                        </div>
                                    </div>
                                ),
                                okText: t('sure'),
                                cancelText: t('ignore'),
                                okButtonProps: {
                                    type: 'primary',
                                    className: 'button-rounded-lg no-border',
                                },
                                cancelButtonProps: {
                                    type: 'text',
                                    className: 'button-rounded-lg no-border',
                                },
                                onOk: () => {
                                    setAttendanceStatus(
                                        {status: attendance_status_options.present.value},
                                        {
                                            attendance_id: item?.attendance?.id,
                                            detail_id: getId(item),
                                        }
                                    )
                                },
                            })
                        }
                    }}>
                    {t(params.label)}
                </Button>
            )
        },
        [courseClass, student]
    )

    const {attendance, number_of_sessions} = current ?? {}

    const {
        fullname,
        prefix_title,
        patron_saint_name,
        contact_phone,
        contact_email,
        contact_address,
        gender,
        date_of_birth,
        place_of_birth,
        parish,
        religious_order,
        religious_order_name,
    } = student ?? {}

    return renderIf(
        courseClass && student,
        <div className="flex flex-col gap-3 p-3">
            <div className="flex flex-col gap-2 mb-3">
                <HeaderWithIconLine
                    renderTitle={() => (
                        <div className="flex items-center gap-2">
                            <BsInfoCircleFill size={14} className="text-color-500"/>
                            <span className="font-semibold text-sm text-color-400 uppercase tracking-wider">
                                {t('student information')}
                            </span>
                        </div>
                    )}
                />
                <div className="ml-3 space-y-2">
                    <ItemInformation
                        primary={true}
                        className="text-xs"
                        label="full name"
                        value={`${prefix_title || patron_saint_name || ''} ${fullname}`}
                    />
                    <ItemInformation className="text-xs italic" label="gender" value={t(getLabelOfGender(gender))}/>
                    <DatePlaceItem
                        label="date of birth"
                        date={date_of_birth ? formatDate(date_of_birth, 'DD/MM/YYYY') : t('not update')}
                        place={place_of_birth}
                        className="text-xs italic"
                    />
                    <DoubleValueItem
                        labelFirst={t('contact')}
                        valueFirst={contact_phone}
                        labelSecond={contact_email && " - " || ''}
                        valueSecond={contact_email}
                        className="text-xs iatlic"
                    />
                    <ItemInformation
                        className="text-xs"
                        label="address"
                        value={contact_address}
                    />
                    {renderIf(
                        parish,
                        <DoubleValueItem
                            labelFirst="parish"
                            valueFirst={parish?.name}
                            labelSecond={_.get(parish, 'diocese_fullname') ? ' - ' : ''}
                            valueSecond={_.get(parish, 'diocese_fullname')}
                            className="text-xs italic"
                        />
                    )}
                    {renderIf(
                        religious_order_name,
                        <ItemInformation
                            label="belong to religious order"
                            value={
                                <Link to={getLinkToDetail(religious_order)} className="no-underline">
                                    {religious_order_name}
                                </Link>
                            }
                            className="text-xs italic"
                        />
                    )}
                </div>
            </div>
            <div className="flex flex-col gap-3">
                <ListHeaderLineAndDes
                    renderTitle={() => (
                        <span className="font-semibold text-sm text-color-400 uppercase tracking-wider">
                                {t('list of lesson')}
                            </span>
                    )}
                    description={t('list of lesson description')}
                />
                <EntityList
                    apiInfo={apiInfo}
                    values={{keyword}}
                    refreshKey={refreshKey}
                    query={bindQueryParams([
                        {id: courseClass?.id},
                        {student_id: student?.id},
                    ])}
                    renderItem={renderAttendantDetail({
                        renderActions,
                        primary_type: 'attendance',
                    })}
                />
            </div>
            {renderIf(
                current,
                <Modal
                    footer={null}
                    open={current}
                    onCancel={onCancel}
                    destroyOnHidden={true}
                    className="custom-modal"
                    title={
                        <div className="text-center text-color-000 font-bold uppercase">
                            {t('student requests absence')}
                        </div>
                    }>
                    <div className="flex flex-col gap-4">
                        <div className="flex flex-col gap-2">
                            <div className="font-semibold text-sm text-color-300 uppercase tracking-wide">
                                {t('lesson information')}
                            </div>
                            <div className="space-y-2">
                                <ItemInformation label="lesson on" value={getTitle(attendance)} className="text-xs"/>
                                <ItemInformation label="number of sessions"
                                                 value={`${number_of_sessions} ${t('sessions')}`}
                                                 className="text-xs"/>
                                <ItemInformation label="subjects" value={getTitle(_.get(attendance, 'subject'))}
                                                 className="text-xs"/>
                            </div>
                        </div>
                        <CheckInContent
                            item={current}
                            status_options={status_options}
                            onSubmit={(values) => {
                                setAttendanceStatus(values, {
                                    attendance_id: current?.attendance?.id,
                                    detail_id: getId(current),
                                })
                                onCancel()
                            }}
                        />
                    </div>
                </Modal>
            )}
        </div>
    )
}


const renderAttendanceStats =
    ({renderActions} = {}) =>
        (item, index) => {
            const {student, number_of_sessions, total_sessions, passed_attendance_status, eligibility_status} = item ?? {}

            const {prefix_title, fullname} = student ?? {}

            const percent_sessions = ((total_sessions / number_of_sessions) * 100).toFixed(2)
            let label_status
            let color_status
            switch (passed_attendance_status) {
                case 1:
                    label_status = 'passed'
                    color_status = 'text-green-600'
                    break
                case 0:
                    label_status = 'failed'
                    color_status = 'text-red-600'
                    break
                default:
                    label_status = 'not assessed yet'
                    color_status = 'text-color-300'
                    break
            }

            return (
                <Translate>
                    {(t) => (
                        <div
                            key={index}
                            className="px-2 py-1 flex items-center border border-color-50 hover:shadow-items-md rounded-md relative">
                            <div className="w-full flex items-center gap-3">
                                <div className="flex flex-col flex-1 truncate">
                                    <div className="font-bold text-sm text-color-000 italic tracking-wide truncate">
                    <span className="font-medium text-color-200">
                        {`${index + 1}. `}
                    </span>
                                        {renderIf(
                                            prefix_title,
                                            <span className="mr-1 font-medium text-color-200">
                          {prefix_title}{' '}
                      </span>
                                        )}
                                        {fullname}
                                    </div>
                                    <div className="ml-1 space-x-1 leading-tight">
                      <span className="text-xs text-color-400">
                          {`${t('number of completed class sessions')} : `}
                      </span>
                                        <span className="font-bold text-xs text-color-100">
                          {total_sessions}/{number_of_sessions} {`( ${percent_sessions}% )`}
                      </span>
                                    </div>
                                </div>
                                <div className="flex flex-col items-end">
                                    <div
                                        className={classNames("font-bold text-xs tracking-wide uppercase opacity-80", color_status)}>
                                        {t(label_status)}
                                    </div>
                                    {
                                        renderIfElse(
                                            eligibility_status,
                                            <div className="font-bold text-2xs tracking-wide uppercase text-green-800">
                                                {t('eligible has been granted')}
                                            </div>,
                                            <div className="font-bold text-2xs tracking-wide uppercase">
                                                ---
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    )}
                </Translate>
            )
        }

export const CourseClassStudentAttendanceStats = ({courseClass}) => {
    const t = useTranslate()
    const [current, setCurrent] = useState()
    const [subject, setSubject] = useState(null)
    const [rateFilter, setRateFilter] = useState(null)

    const onCancel = () => {
        setCurrent(null)
    }

    const apiInfo = course_class_student_getAttendanceResult_Api

    const refreshKey = useMemo(
        () =>
            [
                apiInfo.path
                    .replace(':course_class_id', courseClass?.id)
                    .replace(':subject_id', subject?.id),
                rateFilter
            ].join('/'),
        [courseClass, subject, rateFilter]
    )

    const {passed_attendance_percentage} = subject ?? {};

    let rangeOptions = [];
    if (passed_attendance_percentage > 0 && passed_attendance_percentage <= 100) {
        rangeOptions = [{value: "0-50", label: '{} < 50%'}];
        let range = 50;
        while (range < passed_attendance_percentage) {
            rangeOptions = [...rangeOptions, {
                value: range + "-" + (range + 5),
                label: range + '%' + ' <= {} < ' + (range + 5) + '%'
            }];
            range += 5;
        }
        rangeOptions = [...rangeOptions, {
            value: passed_attendance_percentage + "-" + 100,
            label: '{} >= ' + passed_attendance_percentage + '%'
        }];
    } else {
        rangeOptions = [{value: "0", label: '0% <= {} <= 100%'}];
    }

    return (
        <div className="flex flex-col gap-3 p-3">
            <div className="flex flex-col gap-2 mb-3">
                <ListHeaderLineAndDes
                    title="choose subject"
                    description="choose subject attendance statistics"
                />
                <SubjectSelector
                    value={subject}
                    onChange={(e, ...rest) => {
                        const subject = e.target.value;
                        setSubject(subject)
                    }}
                    course_id={courseClass?.course?.id}
                />
                <div className="flex items-center gap-3">
          <span className="text-sm text-color-400 italic whitespace-no-wrap">
            {`${t('filter by range of values')} : `}
          </span>
                    <SelectWidget
                        value={rateFilter}
                        allowClear={true}
                        className="w-full"
                        defaultValue="vi"
                        placeholder={t('select')}
                        onChange={(value) => {
                            setRateFilter(value)
                        }}
                        options={rangeOptions.map(deepTranslate(t))}
                    />
                </div>
                {renderIf(
                    passed_attendance_percentage > 0,
                    <span className="mt-1 font-bold text-sm text-green-600 italic">
              <span className="font-medium text-color-200 italic">
                  {`* ${t('passed attendance percentage')} : `}
              </span>
                        {passed_attendance_percentage}%
          </span>
                )}
            </div>
            <div className="flex flex-col gap-3">
                <ListHeaderWithLine
                    title="list of students"
                    className="text-sm"
                />
                <EntityList
                    apiInfo={apiInfo}
                    key={refreshKey}
                    query={bindQueryParams([
                        {course_class_id: courseClass?.id},
                        {subject_id: subject?.id},
                    ])}
                    values={{
                        range: rateFilter
                    }}
                    renderEmpty={renderEmptyHolder}
                    renderItem={renderAttendanceStats({})}
                    RenderEntity={React.Fragment}
                />
            </div>
        </div>
    )
}
